import { x } from '@xstyled/styled-components';
import React, { Children } from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { LAYOUT_GRID } from '../itemIds';

interface Props {
  gridTemplateColumns?: string | { _: string; lg: string };
  gridTemplateRows?: string | { _: string; lg: string };
}

export type LayoutGridDefinition = ItemDefinition<typeof LAYOUT_GRID, Props>;

export class LayoutGrid extends Item<typeof LAYOUT_GRID, Props> {
  protected render({
    gridTemplateColumns,
    gridTemplateRows,
    children
  }: RenderProps<Props>) {
    const childArray = Children.toArray(children);

    if (!gridTemplateColumns) {
      gridTemplateColumns = {
        _: '1fr',
        lg: `repeat(2, 1fr)`
      };
    }

    if (!gridTemplateRows) {
      gridTemplateRows = {
        _: `repeat(${childArray.length}, auto)`,
        lg: `repeat(${childArray.length / 2}, 300px)`
      };
    }

    return (
      <x.div
        w="100%"
        maxWidth="1500px"
        h="100%"
        px={{ _: 'md', md: 'md', lg: 'xl' }}
        py={{ _: 'xxxl', md: 'xl', lg: 'xl' }}
        gap={{ _: 'md', md: 'md', lg: 'xl' }}
        mx="auto"
        display="grid"
        alignContent="center"
        gridAutoFlow={{ _: 'row', lg: 'column' }}
        gridTemplateColumns={gridTemplateColumns}
        gridTemplateRows={gridTemplateRows}
        aria-live="polite"
      >
        {childArray.map((c, i) => (
          <x.div key={i}>{c}</x.div>
        ))}
      </x.div>
    );
  }
}

registry[LAYOUT_GRID] = LayoutGrid;
